import * as React from 'react';

import { Box, Button, Flex, Text } from '@opendoor/bricks/core';
import { GoogleMapDisplay } from '@opendoor/cinderblocks/growth/GoogleMapDisplay';

import { CasaAddress } from './UnsubscribePage';

interface IVerifyAddressPageProps {
  casaAddress: CasaAddress;
  googleMapsApiKey: string;

  googleMapsOptions?: React.ComponentProps<typeof GoogleMapDisplay>['options'];
  toManualAddressVerification: () => void;
  unsubscribeAddress: () => void;
}

interface IState {
  loadingUnsubscribe: boolean;
}

interface ICenter {
  lat: number;
  lng: number;
}

export class VerifyAddressPage extends React.PureComponent<IVerifyAddressPageProps, IState> {
  public state: IState = {
    loadingUnsubscribe: false,
  };

  public render() {
    const { casaAddress, googleMapsApiKey, googleMapsOptions } = this.props;
    const center = { lat: casaAddress.latitude, lng: casaAddress.longitude } as ICenter;
    const unit = casaAddress.unitType + ' ' + casaAddress.unitNumber;

    return (
      <Box
        flex={['1 0 auto', null, '0 1 auto']}
        minWidth={['0px', null, '600px']}
        textAlign="center"
      >
        <Box mb={8} width="100%">
          <GoogleMapDisplay
            options={googleMapsOptions}
            center={center}
            googleMapsApiKey={googleMapsApiKey}
            height="300px"
          />
        </Box>
        <Text fontSize="s3" fontWeight="semibold" mb={6} lineHeight="s3">
          {casaAddress.street}
          {unit && `, ${unit}`}
          <br />
          {casaAddress.city}, {casaAddress.state} {casaAddress.postalCode}
        </Text>
        <Text fontSize="s1" mb={8}>
          Is this the correct address?
        </Text>
        <Flex flexDirection={['column', null, 'row']} width="100%">
          <Button
            mr={[null, null, 4]}
            mb={[3, null, 0]}
            onClick={this.handleUnsubscribe}
            loading={this.state.loadingUnsubscribe}
            aria-label="Confirm address is correct"
            analyticsName="cosmos-verify-address-page-confirm-correct-address"
          >
            Yes, that's right
          </Button>
          <Button
            variant="secondary"
            onClick={this.props.toManualAddressVerification}
            aria-label=""
            analyticsName="cosmos-verify-address-page-fix-address"
          >
            Add unit # or fix address
          </Button>
        </Flex>
      </Box>
    );
  }

  private handleUnsubscribe = () => {
    this.setState({ loadingUnsubscribe: true });
    this.props.unsubscribeAddress();
  };
}
